module.exports = {"data":{"data":{"userName":"zhangsan","isBind":false,"getRegistGift":true,"inviteCount":5},"result":1,"message":"0未登录，1成功，2未绑定角色，3账号已经鉴定过了，不能重复鉴定"}}


//////////////////
// WEBPACK FOOTER
// ./src/api/isLogined.json
// module id = qL0y
// module chunks = 1